import { FC } from 'react';

type Props = {
	className?: string;
};

const OwnersIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				d='M3.54297 5.83333C3.54297 3.64721 5.31518 1.875 7.5013 1.875C9.68747 1.875 11.4596 3.64721 11.4596 5.83333C11.4596 8.01946 9.68747 9.79167 7.5013 9.79167C5.31518 9.79167 3.54297 8.01946 3.54297 5.83333Z'
				fill='inherit'
				stroke='transparent'
			/>
			<path
				d='M1.04297 15.8337C1.04297 13.1873 3.18827 11.042 5.83464 11.042H9.16797C11.8143 11.042 13.9596 13.1873 13.9596 15.8337C13.9596 17.0993 12.9336 18.1253 11.668 18.1253H3.33464C2.06899 18.1253 1.04297 17.0993 1.04297 15.8337Z'
				fill='inherit'
				stroke='transparent'
			/>
			<path
				d='M11.1484 9.55367C11.5711 9.70767 12.0274 9.79167 12.5034 9.79167C14.6895 9.79167 16.4618 8.01946 16.4618 5.83333C16.4618 3.64721 14.6895 1.875 12.5034 1.875C12.0274 1.875 11.5711 1.95901 11.1484 2.113C12.1132 3.05833 12.7118 4.37592 12.7118 5.83333C12.7118 7.29074 12.1132 8.60833 11.1484 9.55367Z'
				fill='inherit'
				stroke='transparent'
			/>
			<path
				d='M14.3677 18.1253H16.6672C17.9329 18.1253 18.9589 17.0993 18.9589 15.8337C18.9589 13.1873 16.8137 11.042 14.1672 11.042H12.8477C14.2836 12.1465 15.2089 13.882 15.2089 15.8337C15.2089 16.7077 14.8924 17.5077 14.3677 18.1253Z'
				fill='inherit'
				stroke='transparent'
			/>
		</svg>
	);
};

export default OwnersIconSolid;
